import { Module } from 'core/Module';
import { Core } from 'core/Core';
import { ScrollbarController } from 'app/chrome/scrollbar/ScrollbarController';
import { MouseController } from 'app/chrome/mouse/MouseController';
import DelayHelper from 'utils/timers';
import fastdom from 'fastdom';

export class DragableVideo extends Module {
	private _scrollbar: ScrollbarController;
	private _$interactiveArea: HTMLElement;
	private _interativeAreaClickable: Boolean = false;
	private _interativeAreaFullyClickable: Boolean = false;
	//DelayHelper.setTimeout id (number | string); also passed to native clearTimeout
	//at the call site, which does not cancel DelayHelper timers (pre-existing quirk):
	private _timeout: any;
	private _mouse: MouseController;
	private _mouseHidden: boolean;

	private _isIntersecting: boolean;
	private _rect: DOMRect;

	public create(): void {
		this._mouse = Core.controller.get('Mouse') as MouseController;
		this._scrollbar = Core.controller.get('Scrollbar') as ScrollbarController;
		this._$interactiveArea = this.$container.querySelector('.dragable-embed-video__interactivearea');
	}

	public tick(): void {
		if (!this._interativeAreaClickable && Math.abs(this._scrollbar.velocity) < 1) {
			this._interativeAreaClickable = true;

			clearTimeout(this._timeout);
			this._timeout = DelayHelper.setTimeout(() => {
				fastdom.mutate(() => {
					this._$interactiveArea.style.pointerEvents = 'none';
				});

				this._interativeAreaFullyClickable = true;
			}, 500);
		} else if (this._interativeAreaClickable && Math.abs(this._scrollbar.velocity) > 1) {
			this._interativeAreaClickable = false;
			this._interativeAreaFullyClickable = false;

			fastdom.mutate(() => {
				this._$interactiveArea.style.pointerEvents = 'all';
			});

			clearTimeout(this._timeout);
		}

		if (this._interativeAreaFullyClickable) {
			this._hideCursorOnIntertionRollover();
		}

		if (this._mouseHidden) {
			this._showCursorOnOut();
		}
	}

	public destroy(): void {
		this._scrollbar = null;
		this._mouse = null;
		this._$interactiveArea = null;
	}

	private _hideCursorOnIntertionRollover() {
		this._checkIsIntersecting(this._mouse.getMouseCords());
		if (this._isIntersecting && !this._mouseHidden) {
			this._mouseHidden = true;
			this._mouse.setHiddenState(true);
		}
	}

	private _showCursorOnOut() {
		if (!this._interativeAreaClickable) {
			this._mouseHidden = false;
			this._mouse.setHiddenState(false);
			return;
		}

		this._checkIsIntersecting(this._mouse.getMouseCords());
		if (!this._isIntersecting) {
			this._mouseHidden = false;
			this._mouse.setHiddenState(false);
		}
	}

	private _checkIsIntersecting(cords: any): void {
		if (!this._rect) {
			return;
		}

		this._isIntersecting =
			this._rect.x <= cords.x &&
			cords.x <= this._rect.x + this._rect.width &&
			this._rect.y <= cords.y &&
			cords.y <= this._rect.y + this._rect.height;
	}
}
